import React from 'react';
import styles from './HeadlineLoop.module.css';

// Wraps one word of an H1 with the hand-drawn oval signature.
const HeadlineLoop = ({children, color}) => (
    <span className={styles.wrap}>
        {children}
        <svg className={styles.loop} style={{color}} viewBox="0 0 400 120" preserveAspectRatio="none" aria-hidden="true">
            <path
                d="M30 66 C 20 20, 170 6, 250 10 C 360 16, 402 44, 388 76 C 372 110, 220 118, 130 112 C 50 106, 8 90, 22 60"
                fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
        </svg>
    </span>
);

export default HeadlineLoop;
